/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Free_LimitsInputs */

const en_pricing_plans_free_limits = /** @type {(inputs: Pricing_Plans_Free_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["Custom domains","Custom branding","Lifetime updates"]`)
};

const es_pricing_plans_free_limits = /** @type {(inputs: Pricing_Plans_Free_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["Dominios personalizados","Marca personalizada","Actualizaciones de por vida"]`)
};

/**
* | output |
* | --- |
* | "[\"Custom domains\",\"Custom branding\",\"Lifetime updates\"]" |
*
* @param {Pricing_Plans_Free_LimitsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_free_limits = /** @type {((inputs?: Pricing_Plans_Free_LimitsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Free_LimitsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_free_limits(inputs)
	return es_pricing_plans_free_limits(inputs)
});